export const useLRWebSocketV2 = (store) => {
  const wsManager = WebSocketManager.getInstance();

  const onMessage = (rawData) => {
    try {
      const data = JSON.parse(rawData);
      store.dispatch("elections/updatePres2026_2_Home", data);
    } catch (e) {
      console.error("Error parseando datos del WS", e);
    }
  };
  wsManager.addListener("wss://ws.lalr.co/elections/pres", onMessage);
  return {};
};

class WebSocketManager {
  static instance = null;

  constructor() {
    if (WebSocketManager.instance) {
      return WebSocketManager.instance;
    }

    this.ws = null;
    this.listeners = new Set();
    this.reconnectAttempts = 0;
    this.maxReconnectDelay = 64000;
    this.baseDelay = 2000;
    this.reconnectTimeout = null;
    this.isConnecting = false;
    this.echoInterval = null;

    WebSocketManager.instance = this;
  }

  static getInstance() {
    if (!WebSocketManager.instance) {
      WebSocketManager.instance = new WebSocketManager();
    }
    return WebSocketManager.instance;
  }

  calculateReconnectDelay() {
    return Math.min(
      this.maxReconnectDelay,
      Math.pow(2, this.reconnectAttempts) * this.baseDelay,
    );
  }

  clearReconnectTimeout() {
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }
  }

  setupWebSocket(ws_uri) {
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      this.ws = new WebSocket(ws_uri);

      this.ws.addEventListener("open", () => {
        this.reconnectAttempts = 0;
        this.isConnecting = false;
        this.sendEcho();
      });

      this.ws.addEventListener("message", (event) => {
        this.listeners.forEach((listener) => listener(event.data));
      });

      this.ws.addEventListener("close", () => {
        this.isConnecting = false;

        if (this.reconnectAttempts < 6) {
          const delay = this.calculateReconnectDelay();
          console.log(`Retrying connect ws in ${delay / 1000} secs...`);

          this.clearReconnectTimeout();
          this.reconnectTimeout = setTimeout(() => {
            this.reconnectAttempts++;
            this.connect(ws_uri);
          }, delay);
        } else {
          console.log("Maximum tries reached.");
          if (this.echoInterval) {
            clearInterval(this.echoInterval);
          }
        }
      });

      this.ws.addEventListener("error", (error) => {
        console.error("Websocket error:", error);
      });
    }
  }

  connect(ws_uri) {
    if (this.isConnecting) return;

    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      this.isConnecting = true;
      this.setupWebSocket(ws_uri);
    }

    return this.ws;
  }

  addListener(ws_uri, callback) {
    this.listeners.add(callback);

    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      this.connect(ws_uri);
    }
  }

  removeListener(callback) {
    this.listeners.delete(callback);
  }

  disconnect() {
    this.clearReconnectTimeout();

    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }

    this.reconnectAttempts = 0;
    this.isConnecting = false;
  }

  sendEcho() {
    this.echoInterval = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send("1");
      }
    }, 45000);
  }

  getStatus() {
    if (!this.ws) return "NONE";

    switch (this.ws.readyState) {
      case WebSocket.CONNECTING:
        return "CONNECTING";
      case WebSocket.OPEN:
        return "OPEN";
      case WebSocket.CLOSING:
        return "CLOSING";
      case WebSocket.CLOSED:
        return "CLOSED";
      default:
        return "NONE";
    }
  }
}
